import { render, staticRenderFns } from "./SourceLinkItem.vue?vue&type=template&id=202917d8&"
import script from "./SourceLinkItem.vue?vue&type=script&lang=js&"
export * from "./SourceLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports